import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps } from "vue"

export interface IconCheckboxProps {
  value: string;
  onIcon: string;
  offIcon: string;
  onColor?: string;
  offColor?: string;
  label: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'IconCheckbox',
  props: /*@__PURE__*/_mergeModels({
    value: {},
    onIcon: {},
    offIcon: {},
    onColor: { default: "white" },
    offColor: { default: "gray" },
    label: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const modelValue = _useModel(__props, "modelValue");
const props = __props;

function update() {
  if (typeof modelValue.value === "boolean") {
    modelValue.value = !modelValue.value;
  } else { // it's an array
    const index = modelValue.value.indexOf(props.value);
    if (index >= 0) {
      modelValue.value = modelValue.value.slice(0, index).concat(modelValue.value.slice(index + 1));
    } else {
      modelValue.value = [...modelValue.value, props.value];
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!

  return (_openBlock(), _createBlock(_component_v_checkbox, _mergeProps({
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue).value = $event)),
    value: __props.value
  }, props), {
    label: _withCtx(() => [
      _createElementVNode("span", {
        onClick: _cache[0] || (_cache[0] = () => update())
      }, _toDisplayString(__props.label), 1)
    ]),
    input: _withCtx(({ model }) => [
      ((model.value ? __props.onIcon : __props.offIcon)?.startsWith('fa-'))
        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
            key: 0,
            icon: model.value ? __props.onIcon : __props.offIcon,
            class: _normalizeClass(['fa-icon', model.value ? 'icon-checkbox--checked' : '']),
            color: model.value ? __props.onColor : __props.offColor,
            onClick: ($event: any) => (model.value = !model.value)
          }, null, 8, ["icon", "class", "color", "onClick"]))
        : (_openBlock(), _createBlock(_component_v_icon, {
            key: 1,
            class: _normalizeClass(['md-icon', model.value ? 'icon-checkbox--checked' : '']),
            color: model.value ? __props.onColor : __props.offColor,
            onClick: ($event: any) => (model.value = !model.value)
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(model ? __props.onIcon : __props.offIcon), 1)
            ]),
            _: 2
          }, 1032, ["class", "color", "onClick"]))
    ]),
    _: 1
  }, 16, ["modelValue", "value"]))
}
}

})